import { DocumentsBreadcrumbMutationTypes } from "./mutation_types"
import { DocumentsBreadcrumbState } from "./state"

export const mutations: StoreMutations<DocumentsBreadcrumbMutationTypes, DocumentsBreadcrumbState> = {
  [DocumentsBreadcrumbMutationTypes.ADD_ITEM]: function (state, item) {
    if (!state.breadcrumb.some(i => i.id === item.id)) { state.breadcrumb.push(item) }
  },
  [DocumentsBreadcrumbMutationTypes.SET_ITEMS]: function (state, items = []) {
    state.breadcrumb = items
  },
  [DocumentsBreadcrumbMutationTypes.REMOVE_ALL_AFTER]: function (state, item) {
    const index = state.breadcrumb.findIndex(i => i.id === item.id)
    state.breadcrumb.splice(index + 1, state.breadcrumb.length - 1)
  },
  [DocumentsBreadcrumbMutationTypes.RESET_BREADCRUMB]: function (state) {
    state.breadcrumb = []
  },
}
